import { render, staticRenderFns } from "./Normas.vue?vue&type=template&id=c933fb22&scoped=true"
import script from "./Normas.vue?vue&type=script&lang=js"
export * from "./Normas.vue?vue&type=script&lang=js"
import style0 from "./Normas.vue?vue&type=style&index=0&id=c933fb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c933fb22",
  null
  
)

export default component.exports